//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import theme from './ChartTooltipItem.scss';
import StringUtils from 'common/utils/StringUtils';

type Props = {
    theme: Object,
    className?: string,
    color: string,
    label: string,
    value: number,
    valueType: string,
    percentage?: number
};

class ChartTooltipItem extends React.PureComponent<Props, void> {
    render() {
        const {
            theme,
            color,
            label,
            value,
            valueType,
            percentage,
            className
        } = this.props;

        return (
            <div className={classnames(theme.dataItem, className)}>
                <div
                    className={theme.colorCircle}
                    style={{ backgroundColor: color }}
                />
                <div className={theme.dataItemLabelWrap}>
                    <div className={theme.dataItemLabel}>{label}</div>
                    <div className={theme.dataItemValue}>
                        <span className={theme.value}>
                            {`${value || 0} ${valueType || ''}`}
                        </span>
                        {!StringUtils.isEmpty(percentage) ? (
                            <span className={theme.percent}>
                                &nbsp;(
                                {percentage.toFixed(2)}
                                %)
                            </span>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default themr('ChartTooltipItem', theme)(ChartTooltipItem);
